import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";

const base =
  "group inline-flex min-h-[48px] items-center justify-center gap-3 px-6 py-3 font-display text-sm font-medium uppercase tracking-[0.18em] transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.98]";

const variants = {
  primary: "bg-[#781C31] text-[#F6F2F0] hover:bg-[#B8324E]",
  ghost: "border border-[#F6F2F0]/30 text-[#F6F2F0] hover:border-[#F6F2F0] hover:bg-[#F6F2F0] hover:text-[#090909]",
  light: "bg-[#F6F2F0] text-[#090909] hover:bg-[#B8324E] hover:text-[#F6F2F0]",
};

export function Cta({ to, href, children, variant = "primary", testId, className = "", external }) {
  const Icon = href ? ArrowUpRight : ArrowRight;
  const inner = (
    <>
      <span>{children}</span>
      <Icon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" aria-hidden="true" />
    </>
  );
  const cls = `${base} ${variants[variant]} ${className}`;
  if (href) {
    return (
      <a href={href} target={external === false ? undefined : "_blank"} rel="noopener noreferrer" className={cls} data-testid={testId}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testId}>
      {inner}
    </Link>
  );
}
